<template>
  <div class="card shadow-sm h-100">
    <div
      class="card-header py-2 d-flex align-items-center justify-content-between"
      :class="classeCabecalho"
    >
      <h6 class="mb-0 text-white">
        <i :class="[iconeCabecalho, 'me-2']"></i>Detalhe do Relatório
      </h6>
      <span v-if="lote" class="badge bg-light text-dark">{{ rotuloTipo }}</span>
    </div>

    <div class="card-body p-3">
      <div v-if="!lote" class="text-center text-body-secondary py-5">
        <i class="bi bi-clipboard-data fs-2 d-block mb-2"></i>
        <p class="mb-0 small">Selecione um relatório na timeline para ver os detalhes.</p>
      </div>

      <div v-else>
        <div class="d-flex align-items-start gap-2 mb-2">
          <i :class="['fs-4', lote.icone || 'bi-box', classeStatusTexto]"></i>
          <div>
            <div class="fw-semibold text-body-emphasis">{{ lote.nomeSeed }}</div>
            <div class="text-body-secondary small">
              {{ rotuloTipo }}
              <template v-if="lote.versao"> · v{{ lote.versao }}</template>
              <template v-if="lote.itens.length > 1"> · {{ lote.itens.length }} empresas</template>
              <template v-else-if="lote.itens[0]?.empresaId"> · Empresa #{{ lote.itens[0].empresaId }}</template>
              <template v-else> · Global (Master)</template>
            </div>
          </div>
        </div>

        <div class="alert border-0 py-2 small" :class="classeAlerta">
          <strong><i class="bi bi-info-circle-fill me-1"></i>Resumo:</strong>
          {{ lote.titulo }}
        </div>

        <div v-for="(item, idx) in lote.itens" :key="item.id" class="mb-2">
          <div v-if="lote.itens.length > 1" class="small fw-semibold text-body-secondary mb-1">
            <i class="bi bi-building me-1"></i>
            {{ item.empresaId ? `Empresa #${item.empresaId}` : 'Global (Master)' }}
          </div>
          <ul
            v-if="item.detalhes && item.detalhes.length > 0"
            class="list-unstyled mb-0 small seed-relatorio-lista"
          >
            <li
              v-for="(linha, index) in item.detalhes"
              :key="`${idx}-${index}`"
              :class="classeLinha(linha)"
            >
              {{ linha }}
            </li>
          </ul>
        </div>

        <div class="text-body-secondary small mt-2">
          <i class="bi bi-clock me-1"></i>{{ dataFormatada }}
          <template v-if="nomeUsuario">
            · <i class="bi bi-person me-1"></i>{{ nomeUsuario }}
          </template>
          <template v-if="persistido">
            · <span class="badge bg-body-secondary text-body border border-secondary-subtle">Histórico</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatarDataHoraBR } from '@/utils/useDataBR'

const props = defineProps({
  lote: { type: Object, default: null }
})

const ROTULOS_TIPO = {
  executar: 'Execução',
  exportar: 'Exportação',
  reconciliar: 'Reconciliação',
  verificar: 'Verificação'
}

const rotuloTipo = computed(() => ROTULOS_TIPO[props.lote?.itens?.[0]?.tipo] || 'Operação')

const classeCabecalho = computed(() => {
  const status = props.lote?.status
  if (status === 'erro') return 'bg-danger'
  if (status === 'aviso') return 'bg-warning'
  if (status === 'sucesso') return 'bg-success'
  return 'bg-secondary'
})

const iconeCabecalho = computed(() => {
  const status = props.lote?.status
  if (status === 'erro') return 'bi-x-circle-fill'
  if (status === 'aviso') return 'bi-exclamation-triangle-fill'
  if (status === 'sucesso') return 'bi-check-circle-fill'
  return 'bi-info-circle-fill'
})

const classeStatusTexto = computed(() => {
  const status = props.lote?.status
  if (status === 'erro') return 'text-danger'
  if (status === 'aviso') return 'text-warning'
  if (status === 'sucesso') return 'text-success'
  return 'text-body-secondary'
})

const classeAlerta = computed(() => {
  const status = props.lote?.status
  if (status === 'erro') return 'alert-danger'
  if (status === 'aviso') return 'alert-warning'
  if (status === 'sucesso') return 'alert-success'
  return 'alert-secondary'
})

const dataFormatada = computed(() => {
  if (!props.lote?.dataHora) return '-'
  return formatarDataHoraBR(props.lote.dataHora)
})

const nomeUsuario = computed(() => props.lote?.itens?.[0]?.nomeUsuario || null)
const persistido = computed(() => props.lote?.itens?.[0]?.persistido === true)

function classeLinha (linha) {
  const texto = String(linha || '').toUpperCase()
  if (texto.includes('ERRO') || texto.includes('FALHA')) return 'text-danger fw-semibold'
  if (texto.includes('AVISO') || texto.includes('PENDENTE')) return 'text-warning'
  return 'text-body'
}
</script>

<style scoped>
.seed-relatorio-lista li {
  padding: 0.15rem 0;
  border-bottom: 1px dashed var(--bs-border-color);
}

.seed-relatorio-lista li:last-child {
  border-bottom: none;
}
</style>
